module.exports = __webpack_public_path__ + "static/media/Jean_Paul_Becerril_Celis.071f3fcd.jpg";